import React from 'react';
import { t } from '@lingui/macro';

import {
  SearchParamsPetCounts,
  SearchParamsPetType,
} from '@rover/constants/src/translations/sitterProfilePage.constants';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';
import type { PriceTransparencyLevel } from '@rover/types/src/PriceTransparencyLevel';

import { useRevampProfileContext } from '../../hooks/useRevampProfileContext';
import AccordionSection from '../AccordionSection/AccordionSection';
import ServiceSection from '../ServiceSection/ServiceSection';

import { SitterProfileAllServiceExpandEvent } from './analyticsEvents';

type Props = {
  selectedPetType: SearchParamsPetType;
  petCounts: SearchParamsPetCounts;
  selectedDate: Date;
  selectedEndDate?: Date;
  hasDateRange?: boolean;
  priceTransparencyLevel?: PriceTransparencyLevel;
  isShowingPriceInCurrency?: boolean;
  bookingFeePercentage?: string;
};

const MoreServicesSection = ({
  selectedPetType,
  petCounts,
  selectedDate,
  selectedEndDate,
  hasDateRange,
  priceTransparencyLevel,
  isShowingPriceInCurrency,
  bookingFeePercentage,
}: Props): JSX.Element | null => {
  const [numberOfServices, setNumberOfServices] = React.useState(0);
  const { sitterData } = useRevampProfileContext();

  return (
    <AccordionSection
      sectionName="more-services"
      title={t`More Services (${numberOfServices})`}
      onExpand={() => emitAnalyticsEvent(new SitterProfileAllServiceExpandEvent())}
      body={
        <ServiceSection
          sitterProfile={sitterData}
          petType={selectedPetType}
          petCounts={petCounts}
          selectedDate={selectedDate}
          selectedEndDate={selectedEndDate}
          hasDateRange={hasDateRange}
          priceTransparencyLevel={priceTransparencyLevel}
          isShowingPriceInCurrency={isShowingPriceInCurrency}
          bookingFeePercentage={bookingFeePercentage}
          isRevampVersion
          setNumberOfServices={setNumberOfServices}
        />
      }
    />
  );
};

export default MoreServicesSection;
